import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */
import Nav from './nav';
import Slider from './slider';
import NewsList from './newsList';
import ExPlanWrapper from '../../../components/exPlanWrapper';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        // console.log('content=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.content}>
                {/* 头部广告 */}
                {/* <div className={styles.ad_top}>广告占位1000x90</div> */}
                <Nav searchData={content.search} />
                {content.slide ? (
                    <Chip id="55051" type="recommend" title="宣战2020轮播图" groupName="正文" content={content.slide}>
                        <Slider content={content.slide} />
                    </Chip>
                ) : null}
                {/* 正文部分 */}
                <div className={styles.mainBody}>
                    {/* 中部广告 */}
                    <div className={styles.ad_middle} />
                    <div className={styles.yc_m_l}>
                        {content.xzNews ? (
                            <NewsList headLineNew={content.headLineNew} newsList={content.xzNews} />
                        ) : (
                            <p style={{ textAlign: 'center', paddingTop: '30px' }}>暂无内容</p>
                        )}
                    </div>
                    <div className={styles.yc_m_r}>
                        {/* 右侧广告 */}
                        <div className={styles.ad_right} />
                        <div className={styles.mr_bom_box}>
                            {/* 频道介绍 */}
                            <div className={styles.mr_intro}>
                                <h3>频道介绍</h3>
                                <img
                                    className={styles.intro_logo}
                                    src="http://p0.ifengimg.com/fe/zxyc-index/images/logo1_823c17f4.png"
                                    alt=""
                                    title=""
                                />
                                <p className={styles.intro_p}>
                                    中国扶贫 世界贡献<br />
                                    凤凰网大型扶贫报道项目
                                </p>

                                <img
                                    className={styles.intro_erwei}
                                    src="http://p0.ifengimg.com/fe/zxyc-index/images/erwei2_0dd50414.png"
                                    alt=""
                                    title=""
                                />
                                <p className={styles.erwei_p}>
                                    扫描二维码关注<br />凤凰网官方公众号
                                </p>
                            </div>
                            <div className={styles.mr_rec}>
                                <h3>独家策划</h3>
                                <Chip
                                    id="55052"
                                    type="recommend"
                                    title="宣战2020独家策划"
                                    groupName="侧边栏"
                                    content={content.exclusivePlanning}
                                    translate="handlExclusivePlanningData">
                                    <ExPlanWrapper />
                                </Chip>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.foot_top_box}>
                    {/* 底部广告 */}
                    <div className={styles.ad_bottom} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
